import CheckboxFilters from "./filter-components/CheckboxFilters";
import PriceFilter from "./filters/PriceFilter";
import DateRangeFilter from "./filters/DateRangeFilter";
import PersonsFilter from "./filters/PersonsFilter";
import StarsFilter from "./filters/StarsFilter";
import LocationSearchFilter from "./filters/LocationSearchFilter";

const SidebarFilter = ({ countFilterResults }) => {
  return (
    <div style={{ paddingBottom: 60 }}>
      <LocationSearchFilter />
      <DateRangeFilter />
      <PersonsFilter />
      <StarsFilter />
      <PriceFilter />
      <CheckboxFilters countFilterResults={countFilterResults} />
    </div>
  );
};

export default SidebarFilter;
